import { resolveAddressCity } from './addressDisplay';

/** Normalize city / area strings for comparison (Home & Explore use selected address city). */
export function normalizeAreaCity(c: string | undefined | null): string {
  return (c || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function areaCitiesMatch(a: string | undefined | null, b: string | undefined | null): boolean {
  const x = normalizeAreaCity(a);
  const y = normalizeAreaCity(b);
  if (!x && !y) return true;
  if (!x || !y) return false;
  return x === y;
}

export function addressIdsEqual(a: unknown, b: unknown): boolean {
  if (a == null || b == null) return false;
  return String(a) === String(b);
}

const SERVICE_AREA_ALIASES: Record<string, string> = {
  bhadravati: 'Shivamogga',
  bhadravathi: 'Shivamogga',
  shimoga: 'Shivamogga',
};

export function normalizeKnownServiceArea(city: string): string {
  const trimmed = city.trim();
  return SERVICE_AREA_ALIASES[trimmed.toLowerCase()] ?? trimmed;
}

/** Prefer district, then parsed city — matches backend `area_city` in location table (aligned with OTS app). */
export function pickAddressCity(addr: Record<string, unknown> | null | undefined): string {
  if (!addr || typeof addr !== 'object') return '';
  const pick = (k: string) => {
    const v = addr[k];
    return typeof v === 'string' ? v.trim() : '';
  };
  const district =
    pick('district') ||
    pick('state_district') ||
    pick('address_district') ||
    pick('county');
  if (district) return district;
  return (
    resolveAddressCity(addr) ||
    pick('city') ||
    pick('address_city') ||
    pick('addressCity') ||
    ''
  );
}

/**
 * `area_city` for GET /services-catageory and GET /services.
 * Selected address → first saved address → browser geolocation city.
 */
export function resolveAreaCityForServicesApi(
  addresses: unknown[] | undefined,
  selectedAddressId: string | null | undefined,
  locationAreaCity: string | undefined
): string | undefined {
  const list = Array.isArray(addresses) ? addresses : [];
  let addr: Record<string, unknown> | null = null;
  if (selectedAddressId) {
    const found = list.find((a) => addressIdsEqual((a as { id?: unknown })?.id, selectedAddressId));
    if (found && typeof found === 'object') addr = found as Record<string, unknown>;
  }
  if (!addr && list.length > 0) {
    const first = list[0];
    if (first && typeof first === 'object') addr = first as Record<string, unknown>;
  }
  const fromAddr = pickAddressCity(addr);
  if (fromAddr) return normalizeKnownServiceArea(fromAddr);
  const gps = locationAreaCity?.trim();
  return gps ? normalizeKnownServiceArea(gps) : undefined;
}
